import { useNavigation } from '@react-navigation/native'
import React from 'react'
import styled from 'styled-components/native'

import { LOCATION_TITLE_MAX_WIDTH } from 'features/location/components/LocationWidget'
import { UseNavigationType } from 'features/navigation/navigators/RootNavigator/types'
import { AccessibilityRole } from 'libs/accessibilityRole/accessibilityRole'
import { LocationMode } from 'libs/location/types'
import { useLocationMode, useLocationLabel } from 'libs/locationV2/location.store'
import { getComputedAccessibilityLabel } from 'shared/accessibility/helpers/getComputedAccessibilityLabel'
import { useMobileFontScaleToDisplay } from 'shared/accessibility/helpers/zoomHelpers'
import { TouchableOpacity } from 'ui/components/TouchableOpacity'
import { LocationPointer } from 'ui/svg/icons/LocationPointer'
import { Typo } from 'ui/theme'

export const LocationWidgetBadge = () => {
  const { navigate } = useNavigation<UseNavigationType>()
  const numberOfLines = useMobileFontScaleToDisplay({ default: 1, at200PercentZoom: 3 })

  const selectedLocationMode = useLocationMode()

  const locationTitle = useLocationLabel()

  const isWidgetHighlighted = selectedLocationMode !== LocationMode.EVERYWHERE

  const computedAccessibilityLabel = getComputedAccessibilityLabel(
    locationTitle,
    'Ouvrir la modale de localisation'
  )

  const onPress = () => {
    navigate('SearchLocationModal')
  }

  return (
    <Container highlighted={isWidgetHighlighted}>
      <LocationButton
        onPress={onPress}
        accessibilityRole={AccessibilityRole.BUTTON}
        accessibilityLabel={computedAccessibilityLabel}>
        {isWidgetHighlighted ? (
          <LocationPointerHighlighted testID="location pointer highlighted" />
        ) : (
          <LocationPointerDefault testID="location pointer default" />
        )}
        <LocationTitle numberOfLines={numberOfLines}>{locationTitle}</LocationTitle>
      </LocationButton>
    </Container>
  )
}
const Container = styled.View<{ highlighted: boolean }>(({ theme, highlighted }) => ({
  flexDirection: 'row',
  minHeight: theme.designSystem.size.spacing.xxl,
  borderRadius: theme.designSystem.size.borderRadius.l,
  paddingHorizontal: theme.designSystem.size.spacing.s,
  borderWidth: 1,
  backgroundColor: highlighted
    ? theme.designSystem.color.background.subtle
    : theme.designSystem.color.background.default,
  borderColor: highlighted
    ? theme.designSystem.color.border.selected
    : theme.designSystem.color.border.default,
}))

const LocationPointerHighlighted = styled(LocationPointer).attrs(({ theme }) => ({
  color: theme.designSystem.color.icon.brandPrimary,
  size: theme.designSystem.size.icon.s,
}))({})

const LocationPointerDefault = styled(LocationPointer).attrs(({ theme }) => ({
  size: theme.designSystem.size.icon.s,
  color: theme.designSystem.color.icon.default,
}))``

const LocationTitle = styled(Typo.BodyAccentXs)(({ theme }) => ({
  marginLeft: theme.designSystem.size.spacing.xs,
  maxWidth: LOCATION_TITLE_MAX_WIDTH,
  color: theme.designSystem.color.text.default,
}))

const LocationButton = styled(TouchableOpacity)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: theme.designSystem.size.spacing.xs,
}))
